import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { getCompanyGroupOptions } from './getCompanyGroupOptions'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'

export const useCtxGroupCompany = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  return useQuery({
    ...getCompanyGroupOptions(companyId, data => data.group),
    enabled: !!companyId
  })
}
